import { render, staticRenderFns } from "./poster-template.vue?vue&type=template&id=e2d39ad0&"
import script from "./poster-template.vue?vue&type=script&lang=js&"
export * from "./poster-template.vue?vue&type=script&lang=js&"
import style0 from "./poster-template.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports